export const version = "abi/5.5.0";
//# sourceMappingURL=_version.js.map